<template>
  <div v-if="isShow">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent, computed, inject, ComputedRef } from 'vue'

export default defineComponent({
  name: 'BTabPane',
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    warn: {
      type:Boolean,
      default: false
    }
  },
  setup (props) {
    const currentTab = inject('currentTab')
    const isShow = computed(function () {
      return (currentTab as ComputedRef).value === props.name
    })
    return { isShow }
  }
})
</script>
